module.exports = __webpack_public_path__ + "static/favicon-0cb34574d40a8784a2aceb981ec725b3.png";